import { create } from 'zustand';
import {
  getUsers,
  getLearningItems,
  getAssignments,
  getUserProgress,
  User,
  LearningItem,
  Assignment,
  UserProgress,
} from '@/services/PagesServices/LearningAssignmentToolService';

interface LearningAssignmentToolState {
  users: User[] | null;
  learningItems: LearningItem[] | null;
  assignments: Assignment[] | null;
  userProgress: UserProgress[] | null;
  loading: boolean;
  error: string | null;

  fetchUsers: () => Promise<void>;
  fetchLearningItems: () => Promise<void>;
  fetchAssignments: () => Promise<void>;
  fetchUserProgress: () => Promise<void>;
}

const useLearningAssignmentToolStore = create<LearningAssignmentToolState>((set, get) => ({
  users: null,
  learningItems: null,
  assignments: null,
  userProgress: null,
  loading: false,
  error: null,

  fetchUsers: async () => {
    try {
      set({ loading: true, error: null });
      const response = await getUsers();
      set({ users: response.data || [], loading: false });
    } catch (error: any) {
      set({ error: error.message, loading: false });
      throw error;
    }
  },

  fetchLearningItems: async () => {
    try {
      set({ loading: true, error: null });
      const response = await getLearningItems();
      set({ learningItems: response.data || [], loading: false });
    } catch (error: any) {
      set({ error: error.message, loading: false });
      throw error;
    }
  },

  fetchAssignments: async () => {
    try {
      set({ loading: true, error: null });
      const response = await getAssignments();
      set({ assignments: response.data || [], loading: false });
    } catch (error: any) {
      set({ error: error.message, loading: false });
      throw error;
    }
  },

  fetchUserProgress: async () => {
    try {
      set({ loading: true, error: null });
      const response = await getUserProgress();
      set({ userProgress: response.data || [], loading: false });
    } catch (error: any) {
      set({ error: error.message, loading: false });
      throw error;
    }
  },
}));

export default useLearningAssignmentToolStore;
